import React, { useState } from 'react';
import { Card, Col, Row, Button, ButtonGroup } from "react-bootstrap";
import { 
  Pocket, 
  CreditCard, 
  Eye, 
  Users, 
  Download, 
  ArrowUpRight, 
  ArrowDownLeft, 
  Briefcase, 
  FileText, 
  Home, 
  TrendingUp,
  Plus,
  Activity
} from 'react-feather';
import TableComponent from "../../../components/widgets/table/index";
import { api_srv } from 'services';
import { useQuery } from 'react-query';

const AccountingWallet = () => {
  // Demo data
  const subscriptionWallet = {
    balance: 10200,
    description: "This wallet is used for Nexus Subscription Services"
  };

  const mainWallet = {
    balance: 18050,
    description: "This wallet is used for Tax Remittance, Tax Commission Payment, Other Bill Payment"
  };


      async function fetch_wallet_details() {
        let resp = await (await api_srv).fetchWalletDetails();
        console.log('THE WALLET DATA', resp);
        return resp.data;
      }
    
      const { data: accountDetails, isLoading, isSuccess, isError, error } = useQuery('walletetails', fetch_wallet_details);

      let account = {};
      if (isLoading) {
        console.log("Loading wallet details...");
      } else if (isError) {
        console.error("Error fetching wallet details:", error);
      } else if (isSuccess && Array.isArray(accountDetails) && accountDetails?.length > 0) {
        account = accountDetails[0] || {}; // Use || to fallback to {} if accountDetails[0] is falsy
      }

      console.log("ACCOUNT===", account)

      async function fetch_transactions(accountNumber) {
        let resp = await (await api_srv).fetchWalletTransactions(accountNumber);
        console.log('THE TRANS DATA', resp);
        return resp.data;
      }


      const { data: walletTransactions, isLoading: transIsLoading, isSuccess: isTransSuccess, isError: isTransError, error: transError } = useQuery(
        ['walletrans', account?.accountNumber], // Include accountNumber in the query key
        () => fetch_transactions(account?.accountNumber), // Pass accountNumber to the fetch function
        {
          enabled: !!account?.accountNumber, // Only fetch if accountNumber exists
        }
      );

      let trans = {};
      if (transIsLoading) {

      } else if (isTransError) {
        console.error("Error fetching transactin history details:", transError);
      } else if (isTransSuccess && Array.isArray(walletTransactions) && accountDetails?.length > 0) {
        trans = walletTransactions || [];
      }

      console.log("HISTORY WALLET TRANS===", trans)

  // Table configuration for the reusable table
  const tableFields = [
    { name: "#" },
    { name: "Sub Category" },
    { name: "Type" },
    { name: "Date" },
    { name: "Currency" },
    { name: "Amount" },
    { name: "Status" },
    { name: "Action" }
  ];

  const tableRowData = [
    { type: "index" }, // # column as index
    { type: "text", field: "transactionSubCategory" },
    { type: "text", field: "transactionType" },
    { type: "text", field: "createdAt" },
    { type: "text", field: "transactionCurrency"},
    { type: "number", field: "transactionAmount" },
    // { type: "text", field: "accountSubType" },
    { type: "text", field: "transactionStatus" },

    {
      type: "action",
      field: "id",
      actions: [
        {
          method: (id) => {
            console.log("View transaction:", id);
            // Add your view logic here
          },
          field: "id",
          title: "View",
        },
      ],
    },
  ];

  return (
    <div className="w-100" style={{ marginLeft: "0.5em" }}>
      {/* Header Section */}
      <div className="mb-5 pb-3 border-bottom">
        <div className="d-flex align-items-center mb-2">
          <Pocket size={28} className="text-primary me-3" />
          <h3 className="mb-0 fw-bold text-dark">Accounting Wallet</h3>
        </div>
        <p className="text-muted mb-0 fs-6">
          Manage your wallet balances and track transactions for various Nexus functions
        </p>
      </div>

      {/* Wallets Section */}
      <Row className="g-4 mb-5">
        {/* Subscription Wallet */}
        {/* <Col xl={6} lg={12}>
          <Card className="h-100 border-0 shadow-sm" style={{ borderRadius: "16px" }}>
            <Card.Body className="p-4">
              <div className="d-flex align-items-center mb-4">
                <div 
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ 
                    width: "48px", 
                    height: "48px", 
                    backgroundColor: "#e3f2fd" 
                  }}
                >
                  <Activity size={24} className="text-primary" />
                </div>
                <div>
                  <h5 className="mb-1 fw-bold text-dark">Subscription Wallet</h5>
                  <small className="text-muted">Nexus Services</small>
                </div>
              </div>

              <div className="mb-4">
                <p className="text-muted mb-1 small">Current Balance</p>
                <h2 className="fw-bold text-primary mb-0">
                  {account.accountCurrency} {account.accountBalance}
                </h2>
              </div>

              <p className="text-muted mb-4 small lh-base">
                {subscriptionWallet.description}
              </p>

              <div className="d-grid gap-2 d-md-flex">
                <Button 
                  variant="outline-primary" 
                  className="d-flex align-items-center justify-content-center px-4 py-2 flex-fill"
                  style={{ borderRadius: "8px", minWidth: "140px" }}
                >
                  <Eye size={16} className="me-2" />
                  View Transactions
                </Button>
                <Button 
                  variant="outline-success" 
                  className="d-flex align-items-center justify-content-center px-4 py-2 flex-fill"
                  style={{ borderRadius: "8px", minWidth: "120px" }}
                >
                  <Plus size={16} className="me-2" />
                  Top Up
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col> */}

        {/* Main Wallet */}
        <Col xl={6} lg={12}>
          <Card className="h-100 border-0 shadow-sm" style={{ borderRadius: "16px", marginLeft: "2m" }}>
            <Card.Body className="p-4">
              <div className="d-flex align-items-center mb-4">
                <div 
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ 
                    width: "48px", 
                    height: "48px", 
                    backgroundColor: "#e8f5e8" 
                  }}
                >
                  <CreditCard size={24} className="text-success" />
                </div>
                <div>
                  <h5 className="mb-1 fw-bold text-dark">Main Wallet</h5>
                  <small className="text-muted">Primary Account</small>
                </div>
              </div>

              <div className="mb-4">
                <p className="text-muted mb-1 small">Current Balance</p>
                <h2 className="fw-bold text-success mb-0">
                  {account.accountCurrency} {account.accountBalance}
                </h2>
              </div>

              <p className="text-muted mb-4 small lh-base">
                {mainWallet.description}
              </p>
{/* 
              <div className="row g-2 mb-3">
                <div className="col-md-6">
                  <Button 
                    variant="outline-warning" 
                    className="d-flex align-items-center justify-content-center w-100 px-3 py-2"
                    style={{ borderRadius: "8px" }}
                  >
                    <ArrowUpRight size={16} className="me-2" />
                    Top Up
                  </Button>
                </div>
                <div className="col-md-6">
                  <Button 
                    variant="outline-info" 
                    className="d-flex align-items-center justify-content-center w-100 px-3 py-2"
                    style={{ borderRadius: "8px" }}
                  >
                    <FileText size={16} className="me-2" />
                    Pay Bills
                  </Button>
                </div>
              </div>

              <div className="row g-2">
                <div className="col-md-6">
                  <Button 
                    variant="outline-secondary" 
                    className="d-flex align-items-center justify-content-center w-100 px-3 py-2"
                    style={{ borderRadius: "8px" }}
                  >
                    <Briefcase size={16} className="me-2" />
                    Commission
                  </Button>
                </div>
                <div className="col-md-6">
                  <Button 
                    variant="outline-primary" 
                    className="d-flex align-items-center justify-content-center w-100 px-3 py-2"
                    style={{ borderRadius: "8px" }}
                  >
                    <Eye size={16} className="me-2" />
                    Transactions
                  </Button>
                </div>
              </div> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Transactions Section */}
      <Card className="border-0 shadow-sm" style={{ borderRadius: "16px" }}>
        <Card.Body className="p-4">
          <div className="d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom">
            <div className="d-flex align-items-center">
              <div 
                className="rounded-circle d-flex align-items-center justify-content-center me-3"
                style={{ 
                  width: "40px", 
                  height: "40px", 
                  backgroundColor: "#f8f9fa" 
                }}
              >
                <Home size={20} className="text-muted" />
              </div>
              <div>
                <h5 className="mb-0 fw-bold text-dark">Main Wallet Transactions</h5>
                <small className="text-muted">Recent transaction history</small>
              </div>
            </div>
            <Button 
              variant="outline-primary" 
              size="sm" 
              className="d-flex align-items-center px-3 py-2"
              style={{ borderRadius: "8px" }}
            >
              <Download size={16} className="me-2" />
              Download Report
            </Button>
          </div>
          {trans.length > 0 && isTransSuccess && (
            <TableComponent
              title="Transaction Details"
              table_fields={tableFields}
              table_data={trans}
              row_data={tableRowData}
              pageSize={10}
              hasAction="true"
            />
          )}

        </Card.Body>
      </Card>
    </div>
  );
};

export default AccountingWallet;